import script from "./Pagenation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Pagenation.vue?vue&type=script&lang=ts&setup=true"

import "./Pagenation.vue?vue&type=style&index=0&id=29ab2c84&lang=css"

const __exports__ = script;

export default __exports__